/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mailbox",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "HookSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "IsmSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "string",
                name: "bridge",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "adapter",
                type: "address",
            },
        ],
        name: "LiquidityLayerAdapterSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destinationDomain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_recipientAddress",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_bridge",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "_messageBody",
                type: "bytes",
            },
        ],
        name: "dispatchWithTokens",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "domains",
        outputs: [
            {
                internalType: "uint32[]",
                name: "",
                type: "uint32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
        ],
        name: "enrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_domains",
                type: "uint32[]",
            },
            {
                internalType: "bytes32[]",
                name: "_addresses",
                type: "bytes32[]",
            },
        ],
        name: "enrollRemoteRouters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_message",
                type: "bytes",
            },
        ],
        name: "handle",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "hook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_interchainGasPaymaster",
                type: "address",
            },
            {
                internalType: "address",
                name: "_interchainSecurityModule",
                type: "address",
            },
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "interchainSecurityModule",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        name: "liquidityLayerAdapters",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "localDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mailbox",
        outputs: [
            {
                internalType: "contract IMailbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "routers",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "setInterchainSecurityModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_bridge",
                type: "string",
            },
            {
                internalType: "address",
                name: "_adapter",
                type: "address",
            },
        ],
        name: "setLiquidityLayerAdapter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "unenrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_domains",
                type: "uint32[]",
            },
        ],
        name: "unenrollRemoteRouters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class LiquidityLayerRouter__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_mailbox, overrides) {
        return super.deploy(_mailbox, overrides || {});
    }
    getDeployTransaction(_mailbox, overrides) {
        return super.getDeployTransaction(_mailbox, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=LiquidityLayerRouter__factory.js.map